exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-atoms-Spinner-___Spinner__green___1kIT7 {\n  fill: #50e6a7;\n}\n\n.src-pc-components-atoms-Spinner-___Spinner__white___1b5M5 {\n  fill: #FFF;\n}\n", ""]);

// exports
exports.locals = {
	"green": "src-pc-components-atoms-Spinner-___Spinner__green___1kIT7",
	"white": "src-pc-components-atoms-Spinner-___Spinner__white___1b5M5"
};